import { render, staticRenderFns } from "./means-add-or-update.vue?vue&type=template&id=2e2817fb&scoped=true&"
import script from "./means-add-or-update.vue?vue&type=script&lang=js&"
export * from "./means-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2817fb",
  null
  
)

export default component.exports